import { ReactComponent as HomeAutoServicesIcon } from '../assets/icons/categories/main/HomeAutoServicesIcon.svg';
import { ReactComponent as ConstructionRenovationIcon } from '../assets/icons/categories/main/ConstructionRennovationIcon.svg';
import { ReactComponent as LifestyleAssistanceIcon } from '../assets/icons/categories/main/LifestyleAssistanceIcon.svg';
import { ReactComponent as BusinessFreelanceIcon } from '../assets/icons/categories/main/BusinessAndFreelanceIcon.svg';

// --- Subcategory Icons ---
import { ReactComponent as ApplianceIcon } from '../assets/icons/categories/ApplianceRepairIcon.svg';
import { ReactComponent as PlumbingIcon } from '../assets/icons/categories/PlumbingServicesIcon.svg';
import { ReactComponent as AutomotiveIcon } from '../assets/icons/categories/AutomotiveServices.svg';
import { ReactComponent as CleaningIcon } from '../assets/icons/categories/CleaningServicesIcon.svg';
import { ReactComponent as ElectricalIcon } from '../assets/icons/categories/ElectricalServicesIcon.svg';
import { ReactComponent as FurnitureIcon } from '../assets/icons/categories/FurnitureServicesIcon.svg';
import { ReactComponent as GardeningIcon } from '../assets/icons/categories/GardeningIcon.svg';
import { ReactComponent as Handyman } from '../assets/icons/categories/HandymanServicesIcon.svg';
import { ReactComponent as DesignArchitecture } from '../assets/icons/categories/DesignArchitecture.svg';
import { ReactComponent as DoorWindowInstallation } from '../assets/icons/categories/DoorWindowInstallation.svg';
import { ReactComponent as GeneralConstruction } from '../assets/icons/categories/GeneralConstruction.svg';
import { ReactComponent as InteriorFinishing } from '../assets/icons/categories/InteriorFinishing.svg';
import { ReactComponent as BeautyWellness } from '../assets/icons/categories/BeautyWellness.svg';
import { ReactComponent as EducationTutoring } from '../assets/icons/categories/EducationTutoring.svg';
import { ReactComponent as EventPlanning } from '../assets/icons/categories/EventPlanning.svg';
import { ReactComponent as FitnessHealth } from '../assets/icons/categories/FitnessHealth.svg';
import { ReactComponent as PetServices } from '../assets/icons/categories/PetServices.svg';
import { ReactComponent as PhotographyVideography } from '../assets/icons/categories/PhotographyVideography.svg';
import { ReactComponent as PropertyCourier } from '../assets/icons/categories/PropertyCourier.svg';
import { ReactComponent as AudioMusicProduction } from '../assets/icons/categories/AudioMusicProduction.svg';
import { ReactComponent as ItDevelopment } from '../assets/icons/categories/ItDevelopment.svg';
import { ReactComponent as BusinessSupportConsulting } from '../assets/icons/categories/BusinessSupportConsulting.svg';
import { ReactComponent as ContentTranslation } from '../assets/icons/categories/ContentTranslation.svg';
import { ReactComponent as DesignCreative } from '../assets/icons/categories/DesignCreative.svg';
import { ReactComponent as DigitalMarketing } from '../assets/icons/categories/DigitalMarketing.svg';
import { ReactComponent as FinanceAccounting } from '../assets/icons/categories/FinanceAccounting.svg';
import { ReactComponent as LegalServices } from '../assets/icons/categories/LegalServices.svg';
import { ReactComponent as RoofingFacade } from '../assets/icons/categories/RoofingFacade.svg';

const CATEGORY_ICON_MAP: { [key: string]: React.FC<any> } = {
  home_auto_services: HomeAutoServicesIcon,
  construction_renovation: ConstructionRenovationIcon,
  lifestyle_assistance: LifestyleAssistanceIcon,
  business_freelance: BusinessFreelanceIcon,
  appliance_repair: ApplianceIcon,
  plumbing_services: PlumbingIcon,
  automotive_services: AutomotiveIcon,
  cleaning_services: CleaningIcon,
  electrical_services: ElectricalIcon,
  furniture_services: FurnitureIcon,
  gardening_landscaping: GardeningIcon,
  handyman_services: Handyman,
  design_architecture: DesignArchitecture,
  door_window_installation: DoorWindowInstallation,
  general_construction: GeneralConstruction,
  interior_finishing: InteriorFinishing,
  roofing_facade_work: RoofingFacade,
  beauty_wellness: BeautyWellness,
  education_tutoring: EducationTutoring,
  event_planning: EventPlanning,
  fitness_health: FitnessHealth,
  pet_services: PetServices,
  photography_videography: PhotographyVideography,
  transport_courier_services: PropertyCourier,
  audio_music_production: AudioMusicProduction,
  business_support_consulting: BusinessSupportConsulting,
  content_translation: ContentTranslation,
  design_creative: DesignCreative,
  digital_marketing: DigitalMarketing,
  finance_accounting: FinanceAccounting,
  it_development: ItDevelopment,
  legal_services: LegalServices,
};

export const getCategoryIcon = (categoryKey: string) => {
  const iconStyle = { width: '100%', height: '100%' };
  const IconComponent = CATEGORY_ICON_MAP[categoryKey.toLowerCase()];
  return IconComponent ? <IconComponent style={iconStyle} /> : null;
};

const rootCategoriesClassMap: Record<string, string[]> = {
  home_auto_services: ['#00FFFF', 'dark'],
  construction_renovation: ['#FF9900', 'dark'],
  business_freelance: ['#9933CC', 'light'],
  lifestyle_assistance: ['#FF4D6A', 'light'],
};

export const getCategoryClass = (categoryKey: string): string[] => {
  return rootCategoriesClassMap[categoryKey] ?? '';
};

export const ROOT_CATEGORY_KEYS = [
  'home_auto_services',
  'construction_renovation',
  'business_freelance',
  'lifestyle_assistance',
];
